import HomepageSlider from "@/components/homepage/HomepageSlider";
import { getColor } from "@/styles/ThemeConfig";
import { useCallback } from "react";
import TourCard from "@/components/homepage/cards/TourCard";
import styled from "@emotion/styled";
import { breakpoints } from "@/styles/sizes";
import Image from "next/image";

const TitleWrapper = styled.div`
    color: ${getColor("gold")};
    text-transform: uppercase;
    margin-bottom: 10px;
    @media only screen and (${breakpoints.mobile}) {
        padding: 0 10px;
        margin-bottom: 0;
    }
`;

const BackgroundWrapper = styled.div`
    position: relative;
    overflow: hidden;

    img.background-image {
        position: absolute;
        width: 1220px;
        height: 750px;
        object-fit: cover;
        z-index: 0;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    @media only screen and (${breakpoints.mobile}) {
        height: auto;
        min-height: 400px;
    }
    
    .background-image-mobile{
        position: absolute;
        object-fit: cover;
        object-position: bottom right;
        top:100px;
    }
`;

const HomepageSliderWrapper = styled.div`
    position: relative;
    z-index: 1;
    padding-top: 150px;
    padding-bottom: 75px;

    @media only screen and (${breakpoints.mobile}) {
        margin-bottom: 75px;
        padding-top: 40px;
        padding-bottom: 40px;
    }
`;

export default function HomepageTopRatedSection({
                                                    title,
                                                    subtitle,
                                                    sliderItems,
                                                    sliderSidebarTitle,
                                                    backgroundImage,
                                                }) {
    const renderTourCard = useCallback(
        (item) => (
            <div style={{ margin: "10px" }}>
                <TourCard item={item} />
            </div>
        ),
        []
    );

    return (
        <div style={{ position: "relative" }}>
            <HomepageSliderWrapper>
                <HomepageSlider
                    items={sliderItems}
                    title={title}
                    subtitle={subtitle}
                    sidebarTitle={sliderSidebarTitle}
                    buttonControlsStyle={"green"}
                    renderItem={renderTourCard}
                />
            </HomepageSliderWrapper>
        </div>
    );
}
